import { take, put, call, fork } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import env from "src/env"
import { REQUESTED_FEATURE_LIST } from "../actions/types"

import {
  requestFeatureListSuccess,
  requestFeatureListError,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

function* request() {
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/features`,
    })

    yield put(requestFeatureListSuccess(response))
  } catch (error) {
    yield put(requestFeatureListError(error))
  }
}

export default function* requestSaga() {
  while (true) {
    const action = yield take(REQUESTED_FEATURE_LIST)
    yield fork(request, action)
  }
}
